import React, { useEffect, useState } from "react";
import axios from "axios";
import { TrendingUp, BadgeDollarSign, FileText } from "lucide-react";
import { formatMoney } from "@/lib/pricing";
import { BACKEND_URL } from "@/lib/backendUrl";

const API = `${BACKEND_URL}/api`;

const Stat = ({ icon: Icon, label, zh, value, accent, testid }) => (
  <div className="flex items-center gap-3 rounded-xl border border-slate-800 bg-[#151D2E] px-3 sm:px-4 py-3 min-w-0" data-testid={testid}>
    <Icon className={`w-5 h-5 shrink-0 hidden sm:block ${accent}`} />
    <div className="min-w-0">
      <div className={`font-mono-num font-black text-base sm:text-lg leading-tight truncate ${accent}`}>{value}</div>
      <div className="text-[10px] sm:text-[11px] uppercase tracking-wider text-slate-500 leading-tight">{label} <span className="font-zh normal-case tracking-normal hidden md:inline">{zh}</span></div>
    </div>
  </div>
);

export default function MonthlySummary({ sym, refreshKey = 0 }) {
  const [s, setS] = useState(null);
  useEffect(() => { axios.get(`${API}/stats/monthly`).then(({ data }) => setS(data)).catch(() => setS(null)); }, [refreshKey]);
  if (!s) return null;
  return (
    <div data-testid="monthly-summary" className="space-y-2">
      <p className="text-xs uppercase tracking-widest text-slate-500 font-semibold">This month · {s.month} <span className="font-zh normal-case tracking-normal">本月业绩</span></p>
      <div className="grid grid-cols-3 gap-2 sm:gap-3">
        <Stat icon={BadgeDollarSign} label="Paid" zh="已收款" value={formatMoney(sym, s.paid_total)} accent="text-emerald-300" testid="monthly-paid-total" />
        <Stat icon={TrendingUp} label="Converted" zh="成交率" value={`${s.conversion_rate}%`} accent="text-sky-300" testid="monthly-conversion" />
        <Stat icon={FileText} label="Quotes" zh="报价" value={`${s.won}/${s.quotes}`} accent="text-amber-300" testid="monthly-quotes" />
      </div>
    </div>
  );
}
